'use client';

import { useCallback, useMemo } from 'react';

import { useSyncSearchParams } from './useSyncSearchParams';

export function useSearchParam(key: string): [string[], (values: string[]) => void] {
  const { get, replaceAll } = useSyncSearchParams();

  const values = useMemo(() => {
    const raw = get(key);
    return raw ? raw.split(',').filter(Boolean) : [];
  }, [get, key]);

  const setValues = useCallback(
    (newValues: string[]) => {
      replaceAll((params) => {
        if (newValues.length > 0) {
          params.set(key, newValues.join(','));
        } else {
          params.delete(key);
        }
      });
    },
    [key, replaceAll]
  );

  return [values, setValues];
}
